/**
 * 消息操作相关的混入
 * 包含复制、编辑、下载等消息操作的方法
 */
import { downloadBlob } from "@/utils/fileDownload";

export default {
  data() {
    return {};
  },
  methods: {
    // 添加消息操作图标
    addMessageActionIcons() {
      setTimeout(() => {
        // 使用 this.$el 限定查询范围，避免多个 AIChat 实例互相干扰
        const container = this.$el || document;
        const messages = container.querySelectorAll(".vac-message-box");

        messages.forEach((messageBox) => {
          // 如果已有旧的操作区域，移除后用最新状态重建
          const existing = messageBox.querySelector(
            ".message-actions-container",
          );
          if (existing) existing.remove();

          // 创建操作图标容器
          const actionsContainer = document.createElement("div");

          // 根据vue-advanced-chat的类名识别用户消息和AI消息
          // 用户消息有vac-offset-current类
          const isUserMessage =
            messageBox.classList.contains("vac-offset-current");

          // 找到父级的vac-message-wrapper元素，判断是否是正在流式传输的消息
          const parentWrapper = messageBox.closest(".vac-message-wrapper");
          const messageId = parentWrapper ? parentWrapper.id : null;

          // 检查是否为当前正在生成的AI消息
          const isStreamingAIMessage =
            !isUserMessage &&
            this.isStreaming &&
            this.currentAiMessage &&
            this.currentAiMessage._id === messageId;

          // 检查是否为分析过程消息
          const isAnalysisProcessMessage =
            !isUserMessage &&
            this.messages.find(
              (msg) => msg._id === messageId && msg.isAnalysisProcess,
            );

          // 如果是正在生成的AI消息，不添加操作图标
          if (isStreamingAIMessage) return;

          // 根据消息类型设置不同的类名和位置
          if (isUserMessage) {
            actionsContainer.className =
              "message-actions-container user-message-actions";
          } else {
            actionsContainer.className =
              "message-actions-container ai-message-actions";
          }

          // 添加复制图标（对所有消息）
          const copyIcon = document.createElement("button");
          copyIcon.className = "message-action-icon copy-icon";
          copyIcon.innerHTML =
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.33301 4.14517V2.60547C4.33301 2.0877 4.75274 1.66797 5.27051 1.66797H13.3955C13.9133 1.66797 14.333 2.0877 14.333 2.60547V10.7305C14.333 11.2482 13.9133 11.668 13.3955 11.668H11.8384" stroke="#7886A4" stroke-width="1.4"/><path d="M10.7295 4.33203H2.60449C2.08673 4.33203 1.66699 4.75176 1.66699 5.26953V13.3945C1.66699 13.9123 2.08673 14.332 2.60449 14.332H10.7295C11.2473 14.332 11.667 13.9123 11.667 13.3945V5.26953C11.667 4.75176 11.2473 4.33203 10.7295 4.33203Z" stroke="#7886A4" stroke-width="1.4"/></svg>';
          // copyIcon.title = "复制";
          copyIcon.setAttribute("data-tooltip", "复制");
          copyIcon.onclick = () => this.copyMessageContent(messageBox);

          // 为按钮添加tooltip样式
          this.addTooltipStyle(copyIcon);

          actionsContainer.appendChild(copyIcon);

          // 如果是用户消息，添加编辑图标
          if (isUserMessage) {
            const editIcon = document.createElement("button");
            editIcon.className = "message-action-icon edit-icon";
            editIcon.innerHTML =
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.33301 14H14.333" stroke="#7886A4" stroke-width="1.4"/><path d="M3.66699 8.90663V11.3333H6.10606L13.0003 4.43603L10.5654 2L3.66699 8.90663Z" stroke="#7886A4" stroke-width="1.4"/></svg>';
            // editIcon.title = "编辑";
            editIcon.setAttribute("data-tooltip", "编辑");
            editIcon.onclick = () => this.editUserMessage(messageBox);

            // 为按钮添加tooltip样式
            this.addTooltipStyle(editIcon);

            actionsContainer.appendChild(editIcon);
          } else if (!isAnalysisProcessMessage) {
            // AI消息特有的操作（不包括分析过程消息）

            // 添加下载图标
            const downloadIcon = document.createElement("button");
            downloadIcon.className = "message-action-icon download-icon";
            downloadIcon.innerHTML =
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8.00277V14H14V8" stroke="#7886A4" stroke-width="1.4"/><path d="M11 7.66797L8 10.668L5 7.66797" stroke="#7886A4" stroke-width="1.4"/><path d="M7.99707 1V10.6667" stroke="#7886A4" stroke-width="1.4"/></svg>';
            // downloadIcon.title = "下载";
            downloadIcon.setAttribute("data-tooltip", "下载");
            downloadIcon.onclick = () => this.downloadAIMessage(messageBox);

            // 为按钮添加tooltip样式
            this.addTooltipStyle(downloadIcon);

            actionsContainer.appendChild(downloadIcon);

            // 重新生成
            const switchModelIcon = document.createElement("button");
            switchModelIcon.className = "message-action-icon switch-model-icon";
            switchModelIcon.innerHTML =
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.3996 6.66536C13.7819 3.62236 11.0916 1.33203 7.86631 1.33203C4.64104 1.33203 1.9507 3.62236 1.33301 6.66536L3.33301 5.9987" stroke="#7886A4" stroke-width="1.4"/><path d="M1.33301 9.33203C1.9507 12.375 4.64104 14.6654 7.86631 14.6654C11.0916 14.6654 13.7819 12.375 14.3996 9.33203L12.6663 9.9987" stroke="#7886A4" stroke-width="1.4"/></svg>';
            // switchModelIcon.title = "重新生成";
            switchModelIcon.setAttribute("data-tooltip", "重新生成");
            switchModelIcon.onclick = (event) =>
              this.showModelSwitchDropdown(event, messageBox);

            // 为按钮添加tooltip样式
            this.addTooltipStyle(switchModelIcon);

            actionsContainer.appendChild(switchModelIcon);

            // AI消息添加喜欢/不喜欢（放在最后）
            // 1) 前端写死的欢迎消息（_id === 'ai-1'）不展示
            // 2) 携带报告反馈收集组件（.ai-report-feedback-widget）的消息不展示
            const isWelcomeMessage = messageId === "ai-1";
            const hasReportFeedbackWidget = messageBox.querySelector(
              ".ai-report-feedback-widget",
            );
            if (
              !isAnalysisProcessMessage &&
              messageId &&
              !isWelcomeMessage &&
              !hasReportFeedbackWidget
            ) {
              const state = this.messageFeedbackStates[messageId];
              const { likeIcon, dislikeIcon } = this.createFeedbackIcons(
                messageId,
                state,
              );

              if (state && state.status === "dislike") {
                // 已点踩：展示禁用的“不喜欢”和“已评价”文字
                actionsContainer.appendChild(dislikeIcon);
                const evaluatedLabel = document.createElement("span");
                evaluatedLabel.className = "message-feedback-evaluated-label";
                evaluatedLabel.textContent = "已评价";
                actionsContainer.appendChild(evaluatedLabel);
              } else {
                actionsContainer.appendChild(likeIcon);
                actionsContainer.appendChild(dislikeIcon);
              }
            }
          }

          // 将操作图标容器添加到消息框
          messageBox.appendChild(actionsContainer);
        });
      }, 100);
    },

    // 创建喜欢/不喜欢图标
    createFeedbackIcons(messageId, state) {
      const likeIcon = document.createElement("button");
      likeIcon.className = "message-action-icon like-icon";
      likeIcon.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.37227 5.94064V3.19778C9.37227 2.06164 8.45127 1.14062 7.31512 1.14062L4.57227 7.31207V14.8549H12.5403C13.2241 14.8627 13.8092 14.3654 13.9117 13.6892L14.858 7.51778C14.9184 7.11995 14.801 6.71568 14.537 6.41206C14.273 6.10845 13.8889 5.93607 13.4866 5.94064H9.37227Z" stroke="#7886A4" stroke-width="1.4"/><path d="M4.57115 7.24241H2.74029C1.93699 7.2282 1.25027 7.89361 1.14258 8.68976V13.4898C1.25027 14.286 1.93699 14.8754 2.74029 14.8612H4.57115V7.24241Z" stroke="#7886A4" stroke-width="1.4"/></svg>';
      // likeIcon.title = "喜欢";
      likeIcon.setAttribute("data-tooltip", "喜欢");
      likeIcon.disabled = false;
      likeIcon.classList.remove("disabled");

      const dislikeIcon = document.createElement("button");
      dislikeIcon.className = "message-action-icon dislike-icon";
      dislikeIcon.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.62041 10.055V12.7978C6.62041 13.934 7.5414 14.855 8.67755 14.855L11.4204 8.68356V1.14071H3.45241C2.76856 1.13298 2.18351 1.63026 2.08097 2.30643L1.13468 8.47785C1.0743 8.87567 1.19166 9.27994 1.45569 9.58356C1.71972 9.88718 2.10376 10.0596 2.50611 10.055H6.62041Z" stroke="#7886A4" stroke-width="1.4"/><path d="M11.4219 1.14088H13.2527C14.056 1.12667 14.7428 1.71612 14.8504 2.5123V7.31232C14.7428 8.10847 14.056 8.77414 13.2527 8.75994H11.4219V1.14088Z" stroke="#7886A4" stroke-width="1.4"/></svg>';
      // dislikeIcon.title = "不喜欢";
      dislikeIcon.setAttribute("data-tooltip", "不喜欢");

      // 添加tooltip
      this.addTooltipStyle(likeIcon);
      this.addTooltipStyle(dislikeIcon);

      // 根据已有状态设置激活态
      this.applyFeedbackState(messageId, likeIcon, "like", state);
      this.applyFeedbackState(messageId, dislikeIcon, "dislike", state);

      // 点击事件
      likeIcon.onclick = () =>
        this.handleLikeFeedback(messageId, likeIcon, dislikeIcon);

      // 如果已经点踩过，则不再允许点击“不喜欢”
      if (state && state.status === "dislike") {
        dislikeIcon.disabled = true;
        dislikeIcon.classList.add("disabled");
        dislikeIcon.onclick = null;
      } else {
        dislikeIcon.disabled = false;
        dislikeIcon.classList.remove("disabled");
        dislikeIcon.onclick = () =>
          this.handleDislikeFeedback(messageId, dislikeIcon, likeIcon);
      }

      return { likeIcon, dislikeIcon };
    },

    applyFeedbackState(messageId, button, type, passedState) {
      const state = passedState || this.messageFeedbackStates[messageId];
      if (state && state.status === type) {
        button.classList.add("active");
      }
    },

    // 为按钮添加tooltip样式和行为
    addTooltipStyle(button) {
      // 确保图标本身是定位参考点
      button.style.position = "relative";

      // 鼠标移入时创建 / 显示 tooltip
      button.addEventListener("mouseenter", function () {
        const text = this.getAttribute("data-tooltip");
        if (!text) return;

        // 如果已存在 tooltip，先移除，避免重复
        const existing = this.querySelector(".message-action-tooltip");
        if (existing) {
          existing.remove();
        }

        const tooltip = document.createElement("div");
        tooltip.className = "message-action-tooltip";
        tooltip.textContent = text;

        // 采用固定的黑底白字胶囊样式，位置在图标下方
        tooltip.style.position = "absolute";
        tooltip.style.left = "50%";
        tooltip.style.top = "100%";
        tooltip.style.height = "18px";
        tooltip.style.transform = "translateX(-50%)";
        tooltip.style.marginTop = "2px";
        tooltip.style.padding = "4px 8px";
        tooltip.style.backgroundColor = "#000";
        tooltip.style.color = "#fff";
        tooltip.style.borderRadius = "9px";
        tooltip.style.fontSize = "11px";
        tooltip.style.lineHeight = "18px";
        tooltip.style.whiteSpace = "nowrap";
        tooltip.style.zIndex = "1000";
        tooltip.style.pointerEvents = "none";
        tooltip.style.opacity = "0";
        tooltip.style.transition = "opacity 0.18s ease-out";

        this.appendChild(tooltip);

        // 触发淡入效果
        requestAnimationFrame(() => {
          tooltip.style.opacity = "1";
        });
      });

      // 鼠标移出时移除 tooltip
      button.addEventListener("mouseleave", function () {
        const tooltip = this.querySelector(".message-action-tooltip");
        if (tooltip) {
          this.removeChild(tooltip);
        }
      });
    },

    // 复制消息内容
    copyMessageContent(messageBox) {
      console.log("复制");

      // 获取消息内容
      let content = "";
      const isUserMessage =
        messageBox.classList.contains("vac-offset-current");
      const messageWrapper = messageBox.closest(".vac-message-wrapper");
      const messageId = messageWrapper ? messageWrapper.id : null;
      const storedMessage = messageId
        ? this.messages.find((msg) => msg._id === messageId)
        : null;

      if (isUserMessage && storedMessage && storedMessage.rawContent != null) {
        content = storedMessage.rawContent;
      }

      // 查找消息格式容器
      const formatContainer = messageBox.querySelector(".vac-format-container");
      console.log(formatContainer);

      if (!content && formatContainer) {
        // 判断消息类型并提取相应内容
        if (isUserMessage) {
          // 用户消息：尝试获取span内的文本内容
          const userTextSpan = formatContainer.querySelector("span span");
          if (userTextSpan) {
            content = userTextSpan.textContent || "";
          } else {
            // 备选查找方法
            content = formatContainer.textContent || "";
          }
        } else {
          // AI消息：尝试获取markdown内容
          const markdownDiv = formatContainer.querySelector(".markdown-body");
          if (markdownDiv) {
            content = markdownDiv.textContent || "";
          } else {
            // 如果没有markdown容器，尝试直接获取内容
            content = formatContainer.textContent || "";
          }
        }
      }

      // 如果通过DOM无法获取，尝试从消息对象获取
      if (!content || content.trim() === "") {
        if (messageId) {
          const message = this.messages.find((msg) => msg._id === messageId);

          if (message) {
            if (message.senderId === "user" && message.rawContent != null) {
              content = message.rawContent;
            } else if (message.html && message.content) {
              // 创建一个临时元素来提取HTML内容的纯文本
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = message.content;
              content = tempDiv.textContent || tempDiv.innerText || "";
            } else {
              content = message.content || "";
            }
          }
        }
      }

      // 清理内容中可能的尾部空白字符，但保留内部换行和格式
      content = content.replace(/^\s+|\s+$/g, "");
      console.log(content);

      // 复制到剪贴板 - 使用textarea保留格式
      if (content) {
        try {
          // 创建textarea而不是input，保留换行符
          const textarea = document.createElement("textarea");
          textarea.value = content;
          textarea.setAttribute("readonly", ""); // 防止移动设备上显示键盘
          textarea.style.position = "absolute";
          textarea.style.left = "-9999px"; // 移到屏幕外
          textarea.style.top = "0";

          document.body.appendChild(textarea);
          textarea.select();

          // 执行复制命令
          const successful = document.execCommand("copy");
          document.body.removeChild(textarea);

          if (successful) {
            this.$tbMessage({
              text: "复制成功",
              type: "success",
              duration: 1000,
            });
          } else {
            // 如果execCommand复制失败，尝试使用Clipboard API
            if (navigator.clipboard) {
              navigator.clipboard
                .writeText(content)
                .then(() => {
                  this.$tbMessage({
                    text: "复制成功",
                    type: "success",
                    duration: 1000,
                  });
                })
                .catch((err) => {
                  console.error("复制失败:", err);
                  this.$tbMessage({
                    type: "error",
                    text: "复制失败，请重试",
                    duration: 1500,
                  });
                });
            } else {
              this.$tbMessage({
                type: "error",
                text: "复制失败，请重试",
                duration: 1500,
              });
            }
          }
        } catch (err) {
          console.error("复制过程中出错:", err);
          this.$tbMessage({
            type: "error",
            text: "复制失败，请重试",
            duration: 1500,
          });
        }
      } else {
        this.$tbMessage({
          type: "warning",
          text: "没有找到可复制的内容",
          duration: 1500,
        });
      }
    },

    // 编辑用户消息
    editUserMessage(messageBox) {
      console.log("编辑消息开始", messageBox);

      // 获取消息内容
      let originalContent = "";
      const messageWrapper = messageBox.closest(".vac-message-wrapper");
      const messageId = messageWrapper ? messageWrapper.id : null;
      const storedMessage = messageId
        ? this.messages.find((msg) => msg._id === messageId)
        : null;

      // 查找消息格式容器
      const formatContainer = messageBox.querySelector(".vac-format-container");
      console.log("编辑信息 - 消息容器:", formatContainer);

      if (!formatContainer) {
        this.$tbMessage({
          text: "无法找到消息内容容器",
          type: "error",
          duration: 1500,
        });
        return;
      }

      // 获取原始文本内容
      const userTextSpan = formatContainer.querySelector("span span");
      console.log("用户文本元素:", userTextSpan);

      if (storedMessage && storedMessage.rawContent != null) {
        originalContent = storedMessage.rawContent;
      } else if (userTextSpan) {
        originalContent = userTextSpan.textContent || "";
      } else {
        originalContent = formatContainer.textContent || "";
      }

      // 清理内容
      originalContent = originalContent.trim();
      console.log("原始内容:", originalContent);

      if (!originalContent) {
        this.$tbMessage({
          text: "无法获取消息内容",
          type: "error",
          duration: 1500,
        });
        return;
      }

      // 查找并存储消息容器和其原始宽度
      const container = this.$el || document;
      const messageContainer = container.querySelector(
        ".vac-message-container",
      );
      let originalWidth = null;
      if (messageContainer) {
        originalWidth = messageContainer.style.width;
        // 设置消息容器宽度为100%
        messageContainer.style.width = "100%";
        // messageContainer.style.maxWidth = "100%";
      }

      // 创建一个编辑框替换原消息
      const textEditor = document.createElement("textarea");
      textEditor.value = originalContent;
      textEditor.className = "message-edit-textarea";
      textEditor.style.width = "100%";
      textEditor.style.minHeight = "80px";
      textEditor.style.padding = "8px 12px";
      textEditor.style.borderRadius = "8px";
      textEditor.style.border = "1px solid #05ABFA";
      textEditor.style.resize = "vertical";
      textEditor.style.fontFamily = "inherit";
      textEditor.style.fontSize = "14px";
      textEditor.style.lineHeight = "1.4";
      textEditor.style.color = "#0D0E0F";
      textEditor.style.outline = "none";
      textEditor.style.boxSizing = "border-box";

      // 创建操作按钮容器
      const buttonContainer = document.createElement("div");
      buttonContainer.style.display = "flex";
      buttonContainer.style.justifyContent = "flex-end";
      buttonContainer.style.marginTop = "8px";
      buttonContainer.style.gap = "8px";
      buttonContainer.style.width = "100%";

      // 发送按钮
      const saveButton = document.createElement("button");
      saveButton.textContent = "发送";
      saveButton.style.padding = "5px 12px";
      saveButton.style.backgroundColor = "#05ABFA";
      saveButton.style.color = "white";
      saveButton.style.border = "none";
      saveButton.style.borderRadius = "4px";
      saveButton.style.cursor = "pointer";

      // 取消按钮
      const cancelButton = document.createElement("button");
      cancelButton.textContent = "取消";
      cancelButton.style.padding = "5px 12px";
      cancelButton.style.backgroundColor = "#E6ECF9";
      cancelButton.style.color = "#0D0E0F";
      cancelButton.style.border = "none";
      cancelButton.style.borderRadius = "4px";
      cancelButton.style.cursor = "pointer";

      // 添加按钮到容器
      buttonContainer.appendChild(cancelButton);
      buttonContainer.appendChild(saveButton);

      // 创建编辑容器
      const editContainer = document.createElement("div");
      editContainer.className = "message-edit-container";
      editContainer.style.padding = "8px";
      // editContainer.style.backgroundColor = "white";
      editContainer.style.borderRadius = "8px";
      // editContainer.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
      editContainer.style.marginTop = "8px";
      editContainer.style.width = "95%"; // 调整为95%，在100%容器中更好看
      editContainer.style.margin = "20px auto"; // 居中显示
      editContainer.style.boxSizing = "border-box";

      // 添加文本框和按钮到容器
      editContainer.appendChild(textEditor);
      editContainer.appendChild(buttonContainer);

      // 暂存原消息元素
      const messageTextElement = formatContainer.parentElement;

      // 获取消息卡片元素，用于在更合适的位置插入编辑框
      const messageCard = messageBox.closest(".vac-message-wrapper");
      if (!messageCard) {
        console.error("找不到消息卡片元素");
      }

      // 隐藏原消息卡片
      if (messageCard) {
        messageCard.style.display = "none";
      } else {
        messageTextElement.style.display = "none";
      }

      // 找到消息卡片的父元素，用于插入编辑容器
      const cardParent = messageCard
        ? messageCard.parentElement
        : messageTextElement.parentElement;

      // 插入编辑容器到消息卡片后面
      cardParent.insertBefore(
        editContainer,
        messageCard ? messageCard.nextSibling : messageTextElement.nextSibling,
      );

      // 聚焦文本框
      textEditor.focus();

      // 恢复消息容器宽度的函数
      const restoreContainerWidth = () => {
        if (messageContainer && originalWidth !== null) {
          messageContainer.style.width = originalWidth;
          messageContainer.style.maxWidth = "";
        }
      };

      // 保存按钮点击事件
      saveButton.onclick = () => {
        const newContent = textEditor.value.trim();

        if (newContent) {
          // 找到消息元素 - 这里会依赖于消息的DOM结构
          if (userTextSpan) {
            userTextSpan.textContent = newContent;
          }

          // 更新消息内容并发送到AI
          try {
            // 1. 找到当前编辑的消息在消息数组中的位置
            const userMessageIndex = messageId
              ? this.messages.findIndex((msg) => msg._id === messageId)
              : this.messages.findIndex(
                  (msg) =>
                    msg.senderId === "user" &&
                    (msg.rawContent === originalContent ||
                      msg.content === originalContent)
                );

            if (userMessageIndex !== -1) {
              // 更新用户消息
              this.messages[userMessageIndex].content =
                this.formatUserMessageContent(newContent);
              this.messages[userMessageIndex].rawContent = newContent;

              // 2. 删除这条消息之后的所有消息（通常是AI回复）
              if (userMessageIndex < this.messages.length - 1) {
                this.messages.splice(userMessageIndex + 1);
              }
            }

            // 3. 重新渲染消息列表
            this.messages = [...this.messages];

            // 4. 发送到AI
            this.sendToAI(newContent);

            // this.$notify({
            //   message: "消息已发送",
            //   type: "success",
            //   duration: 1000,
            // });
          } catch (err) {
            console.error("发送消息失败:", err);
            this.$tbMessage({
              text: "发送失败，请重试",
              type: "error",
              duration: 1500,
            });
          }
        } else {
          this.$tbMessage({
            text: "消息内容不能为空",
            type: "warning",
            duration: 1500,
          });
          return;
        }

        // 移除编辑容器，显示原消息
        cardParent.removeChild(editContainer);
        if (messageCard) {
          messageCard.style.display = "";
        } else {
          messageTextElement.style.display = "";
        }

        // 恢复消息容器的原始宽度
        restoreContainerWidth();
      };

      // 取消按钮点击事件
      cancelButton.onclick = () => {
        // 移除编辑容器，显示原消息
        cardParent.removeChild(editContainer);
        if (messageCard) {
          messageCard.style.display = "";
        } else {
          messageTextElement.style.display = "";
        }

        // 恢复消息容器的原始宽度
        restoreContainerWidth();
      };

      // ESC键取消编辑
      textEditor.onkeydown = (e) => {
        if (e.key === "Escape") {
          cancelButton.click();
        }
      };
    },

    // 下载AI消息内容
    downloadAIMessage(messageBox) {
      // 获取消息内容
      let content = "";

      // 查找消息格式容器
      const formatContainer = messageBox.querySelector(".vac-format-container");

      if (formatContainer) {
        // AI消息：尝试获取markdown内容
        const markdownDiv = formatContainer.querySelector(".markdown-body");
        if (markdownDiv) {
          content = markdownDiv.textContent || "";
        } else {
          // 如果没有markdown容器，尝试直接获取内容
          content = formatContainer.textContent || "";
        }
      }

      // 如果通过DOM无法获取，尝试从消息对象获取
      if (!content || content.trim() === "") {
        const messageId = messageBox.getAttribute("data-id");

        if (messageId) {
          const message = this.messages.find((msg) => msg._id === messageId);
          if (message) {
            if (message.html && message.content) {
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = message.content;
              content = tempDiv.textContent || tempDiv.innerText || "";
            } else {
              content = message.content || "";
            }
          }
        }
      }

      // 清理内容中可能的尾部空白字符，但保留内部换行和格式
      content = content.replace(/^\s+|\s+$/g, "");

      if (content) {
        try {
          downloadBlob(
            content,
            this.$downloadFileName({
              identifier: this.ai_Model_Types,
              name: `AI消息_${new Date().getTime()}`,
              extension: "txt",
            }),
            "text/plain;charset=utf-8",
          );

          this.$tbMessage({
            text: "下载成功",
            type: "success",
            duration: 1000,
          });
        } catch (err) {
          console.error("下载失败:", err);
          this.$tbMessage({
            text: "下载失败，请重试",
            type: "error",
            duration: 1500,
          });
        }
      } else {
        this.$tbMessage({
          text: "没有找到可下载的内容",
          type: "warning",
          duration: 1500,
        });
      }
    },

    // 重新生成
    showModelSwitchDropdown(event, messageBox) {
      // 防止事件冒泡
      event.stopPropagation();
      console.log(event);
      console.log(messageBox);
      console.log(this.messages);

      // 获取当前消息的上下文
      // 找到父级的vac-message-wrapper元素，它应该有id属性
      const parentWrapper = messageBox.closest(".vac-message-wrapper");
      const messageId = parentWrapper ? parentWrapper.id : null;
      console.log("找到的父元素:", parentWrapper);
      console.log("消息ID:", messageId);

      if (!messageId) {
        this.$tbMessage({
          text: "无法识别消息",
          type: "error",
          duration: 1500,
        });
        return;
      }

      // 找到当前AI消息在消息数组中的位置
      const aiMessageIndex = this.messages.findIndex(
        (msg) => msg._id === messageId,
      );
      if (aiMessageIndex === -1) {
        this.$tbMessage({
          text: "无法找到对应消息",
          type: "error",
          duration: 1500,
        });
        return;
      }

      // 找到这条AI消息之前的用户消息
      let userMessageIndex = -1;
      for (let i = aiMessageIndex - 1; i >= 0; i--) {
        if (this.messages[i].senderId === "user") {
          userMessageIndex = i;
          break;
        }
      }

      if (userMessageIndex === -1) {
        this.$tbMessage({
          text: "无法找到对应的用户问题",
          type: "error",
          duration: 1500,
        });
        return;
      }

      // 获取用户消息内容
      const userMessageObj = this.messages[userMessageIndex];
      const userMessage =
        userMessageObj.rawContent != null
          ? userMessageObj.rawContent
          : userMessageObj.content;

      // 删除当前AI消息
      this.messages.splice(aiMessageIndex, 1);
      this.messages = [...this.messages];

      // 重新发送用户消息到AI
      this.sendToAI(userMessage);
    },

    // 切换到选定的模型
    switchToModel(modelId, modelName) {
      // 此方法已不再使用，保留为空方法以兼容旧代码
      return;
    },
  },
};
